import { KnmPreviewActionsEnum } from '../enums/KnmPreviewActionsEnum';
import { IKnmPreviewState } from '../interfaces/IKnmPreviewState';
import { KnmPreviewAction } from '../types/KnmPreviewAction';

const initial: IKnmPreviewState = {};

export function knmPreviewReducer(state = initial, action: KnmPreviewAction) {
  switch (action.type) {
    case KnmPreviewActionsEnum.KNM_PREVIEW_SET_OPEN_API_INFO: {
      const { openApiInfo } = action.payload;
      const newState: IKnmPreviewState = {
        ...state,
        openApiInfo,
      };

      return newState;
    }
    case KnmPreviewActionsEnum.KNM_PREVIEW_SET_PASSPORT_DATA: {
      const { passportData } = action.payload;
      const newState: IKnmPreviewState = {
        ...state,
        passportData,
      };

      return newState;
    }
    default:
      return state;
  }
}
